import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ItemsTab } from '@b2b/features/cart/utilities/checkout-tabs.model';

@Component({
  selector: 'order-tabs',
  imports: [CommonModule, RouterModule],
  templateUrl: './order-tabs.component.html',
  styleUrls: ['./order-tabs.component.scss'],
})
export class OrderTabsComponent {
  @Input() items?: ItemsTab[];
  @Output() selectTab = new EventEmitter<ItemsTab>();

  onSelectTab(tab: ItemsTab) {
    this.selectTab.emit(tab);
  }
}
